export const UserApi = {
    login: '/api/user/basic/base/login',
    getUserInfo: "/api/user/basic/token/userinfo",
    getAccountRegist: "/api/user/basic/base/regist",
    getAccountForget: "/api/user/basic/forget/password",
    getAccountEmailCode: "/api/user/basic/send/email/code",
    // 谷歌登录
    getAccountGoogleLogin: "/api/user/basic/google/callback/code",
    // 三方linuxDo登录
    getAccountLiunxDoLogin: "/api/user/basic/linuxdo/callback/code",
    getAccountAppleLogin: "/api/user/basic/apple/get/token",
    getWxauthUrlApi: "/api/user/basic/wxauth/get/url",  //获取微信二维码地址
    getWxauthCodeLoginApi: "/api/user/basic/wxauth/code/login",  //通过微信code获取用户登录信息
    getQQauthCodeLoginApi: "/api/user/basic/qqauth/code/login",  //通过QQcode获取用户登录信息
    gettWitterCodeLoginApi: "/api/user/basic/twitter/oauth/login",  //通过twitter获取用户登录信息
    getTwitterOauthUrlApi: "/api/user/basic/twitter/oauth/url",  //获取twitter 授权地址
    getFacebookOauthlogin: "/api/user/basic/facebook/oauth/login",  //获取facebook 授权地址
    getLogout: "/api/user/basic/token/userinfo",  //退出登录
    getRequestConfigById: "/api/user/config/get",  //获取配置信息
    getModifyCompareCfgApi: "/api/user/basic/modify/compare/cfg",  //修改用户的“翻译对比文件样式”设置
    getAccountInfoEdit: "/api/user/basic/modify/userinfo",  //修改用户信息
    getDeleteAccount: "/api/user/basic/delete/self",  //删除用户信息
}
export const BasicApi = {
    getHomePageConfig: '/api/user/config/homepage',
    getRoleRights: '/api/user/basic/get/vip/functions',
    getLocalLanguage: '/api/user/language/config/clientGetLanguageConfig',
    getLanguages: '/api/core/pdf/lang/list',
    getEnterpriseConfig: '/api/user/biz/get/service/functions', // 获取企业权益
    getCurrentLocation: '/api/ip/location', // 获取当前位置
}
// export const TranslateApi = {
//     getTranslateResult: '/api/core/pdf/file/upload',
//     getOperateRecordId: '/api/user/operate/record/get',
//     getRequestCheckFileMD5: '/api/core/pdf/check/same/md5',
//     getTranslate: '/api/core/pdf/translate',
//     getTranslateCheckStatus: '/api/core/pdf/query/status',
//     getEngines: '/api/core/pdf/engines',
//     getLastTranslateConfigApi: "/api/core/pdf/get/last/trans/param" //最近一次翻译参数记录；
// }

// export const TermApi = {
//     getCreateTerm: "/api/user/term/addterm",  // 添加术语库
//     getUserTermlist: "/api/user/term/pctermlist", // 查看用户术语库列表
//     getUserSearchTermlist: "/api/user/term/termlist", // 查看用户术语库搜索列表
//     getDeleteTerm: "/api/user/term/deleteterms", // 删除术语库
//     getEditTerm: "/api/user/term/editterm", // 编辑术语库(重命名)
//     getTermentrylist: "/api/user/term/gettermentrylist", // 查看用户术语库词条列表
//     getAddTermentry: "/api/user/term/addentry", // 添加词条
//     getDeleteTermentry: "/api/user/term/deleteentrys", // 删除词条
//     getEditTermentry: "/api/user/term/editentry", // 编辑词条
//     getTermImportentry: "/api/user/term/importentry", // 导入词库
//     getTermImportterm: "/api/user/term/importterm", // 导入术语库
//     getCheckTermName: "/api/user/term/checktermnameexit", // 检查术语库名称是否存在,true是存在
//     getCheckTermKeyName: "/api/user/term/checkentrykeyexit", // 检查术语库的词条key是否存在,true是存在
//     getExportExcelTerm: "/api/user/term/exceltermentrylist", // 根据术语库id导出词库
//     getArtInfos: "/api/user/operate/record/termuselog", // 查询当前files下使用的术语
// }

// export const ProApi = {
//     getProConfig: "/api/user/biz/all/price/cfg", // 查询价格
//     getBuyTranslateTrade: "/api/user/trade/save", // 用户购买服务【会员or加油包】（生成“交易订单”）
//     // 查询支付状态
//     getStripePayStatus: "/api/user/stripe/session/pay/status",
//     // 检测paypal支付
//     getCheckPayPalStatus: "/api/user/paypal/query/order"
// }

// export const AccountRecordApi = {
//     getTranslateRecordList: '/api/user/operate/record/list/page',
//     getOrderNoList: '/api/user/trade/list',
//     createAccountEnterprise: '/api/user/biz/create', // 创建企业
//     getEnterpriseInfo: '/api/user/biz/get', // 获取企业信息
//     joinEnterprise: '/api/user/biz/member/confirm', // 加入团队
//     getEnterpriseMemberList: '/api/user/biz/get/members', // 查询企业成员列表
//     addMember: '/api/user/biz/add/member', // 添加成员
//     editMember: '/api/user/biz/edit/member', // 编辑成员
//     deleteMember: '/api/user/biz/del/member', // 删除成员
//     deleteFile: '/api/user/operate/record/del', // 删除文件
//     deleteFiles: '/api/user/operate/record/delete/ids' // 批量删除文件
// }

// export const AccountArtApi = {
//     getCreateTerm: "/api/user/term/addterm", // 添加术语库
//     getUserTermlist: "/api/user/term/pctermlist", // 查看用户术语库列表
//     getUserSearchTermlist: "/api/user/term/termlist", // 查看用户术语库搜索列表
//     getDeleteTerm: "/api/user/term/deleteterms", // 删除术语库
//     getEditTerm: "/api/user/term/editterm", // 编辑术语库(重命名)
//     getTermentrylist: "/api/user/term/gettermentrylist", // 查看用户术语库词条列表
//     getAddTermentry: "/api/user/term/addentry", // 添加词条
//     getDeleteTermentry: "/api/user/term/deleteentrys", // 删除词条
//     getEditTermentry: "/api/user/term/editentry", // 编辑词条
//     getTermImportentry: "/api/user/term/importentry", // 导入词库
//     getTermImportterm: "/api/user/term/importterm", // 导入术语库
//     getCheckTermName: "/api/user/term/checktermnameexit", // 检查术语库名称是否存在,true是存在
//     getCheckTermKeyName: "/api/user/term/checkentrykeyexit", // 检查术语库的词条key是否存在,true是存在
//     getExportExcelTerm: "/api/user/term/exceltermentrylist", // 根据术语库id导出词库
//     getArtInfos: "/api/user/operate/record/termuselog", // 查询当前files下使用的术语
//     getAccountFileCompare: "/api/user/operate/record/compare" // 根据id查询“源文件”和“操作后”的文件名
// }

// export const TranslatePageApi = {
//     getAwsUploadFileUrl: "/api/core/tools/get/aws/upload/url",     // 获取AWS亚马逊上传文件的地址URL
//     getForwordPythonApi: "/api/core/tools/forword/python", // 转发到python的api接口，提交编辑后的相关数据
//     rectangleUploadJsonData: "/api/core/pdf/save/edit/trans" // 区域重新翻译逻辑
// }

// export const TranslateEditApi = {
//     getTranslateTextAreaApi: "/api/core/pdf/trans/text/area",  //编辑弹窗，确认翻译引擎调用接口
//     getTranslateEditTransApi: "/api/core/pdf/save/edit/trans",  //编辑弹窗，点击重新翻译，写入数据库，然后完成翻译
//     getIncrOnlineEditStatApi: "/api/core/pdf/incr/online/edit/stat"  //编辑操作统计
// }


export const UploadApi = {
    getUploadFile: "/api/core/pdf/file/upload",
}

export const CommonApi = {
    operateRecordLogs: "/api/core/pdf/get/operate/logs",  // 操作记录日志
    fileRecord: "/api/core/pdf/record/get",  //根据id，查询文件记录信息
    todoOcr: "/api/core/pdf/todo/ocr", // 执行处理OCR
    getContactApi: "/api/core/pdf/save/contact",  //保存联系我们
    getDownloadFileUrl: "/api/core/pdf/download/url", // 获取下载文件地址
    getRecordDestroy: '/api/core/pdf/record/destroy', // 销毁文件
    getNoticeOperate: '/api/core/pdf/notice/operate', // 文件渲染完成操作通知
    getRenewFileOperateTime: '/api/core/pdf/renew/file/operate/time', // 更新文件的“操作时间”
    getAwsUploadFileUrl: "/api/core/pdf/get/aws/upload/url",     // 获取AWS亚马逊上传文件的地址URL
    getPollingAwsUploadFileUrl: "/api/core/pdf/operate/result",     // 获取下载地址， ocr地址轮训接口地址
}

export const LanguageApi = {
    getLanguageConfig: "/api/core/language/config/clientGetLanguageConfig", // 获取语言配置
}

export const SeoCodeApi = {
    getSeoList: "/api/core/seo/list", // 获取SEO列表
}

export const ConfigApi = {
    getHomePageConfig: "/api/core/config/homepage", // 获取首页配置
}